import { render, staticRenderFns } from "./TransactionsListTable.vue?vue&type=template&id=5c0f048c"
import script from "./TransactionsListTable.vue?vue&type=script&lang=js"
export * from "./TransactionsListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports